<app-detail-panel [isOpen]="true" [resizable]="true" [(widthPx)]="width">
  @if (contextDoc(); as doc) {
    <!-- Header -->
    <div class="panel-header">
      <div class="panel-title-row">
        <app-type-icon [icon]="iconConfig().icon" [variant]="iconConfig().variant" />
        <app-editable-panel-title
          [value]="doc.file_name"
          [readonly]="true"
          [ariaLabel]="'panels_ext.file_name_aria' | transloco"
        />
      </div>
      <div class="panel-header-actions">
        <button
          class="panel-icon-btn"
          (click)="contextDocPreview.open(doc)"
          [title]="'detail_panels.preview_title' | transloco"
          [attr.aria-label]="'panels_ext.preview_aria' | transloco"
        >
          <mat-icon>visibility</mat-icon>
        </button>
        <button
          class="panel-icon-btn"
          (click)="onDownload()"
          [disabled]="!canDownload() || isExporting()"
          [title]="
            isExporting()
              ? ('common.exporting' | transloco)
              : canDownload()
                ? ('panels_ext.download_file_aria' | transloco)
                : ('panels_ext.download_unavailable' | transloco)
          "
          [attr.aria-label]="'panels_ext.download_file_aria' | transloco"
        >
          @if (isExporting()) {
            <mat-spinner diameter="18"></mat-spinner>
          } @else {
            <mat-icon>download</mat-icon>
          }
        </button>
        @if (canManage()) {
          <button
            class="panel-icon-btn"
            [attr.aria-label]="'detail_panels.more_options_aria' | transloco"
            [matMenuTriggerFor]="moreMenu"
          >
            <mat-icon>more_vert</mat-icon>
          </button>
        }
        <button
          class="panel-icon-btn"
          (click)="onClose()"
          [attr.aria-label]="'detail_panels.close_panel_aria' | transloco"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <mat-menu #moreMenu="matMenu" class="panel-more-menu">
      <button mat-menu-item (click)="onReplace()">
        <mat-icon>swap_horiz</mat-icon>
        <span>{{ 'common.replace' | transloco }}</span>
      </button>
      <button mat-menu-item class="menu-item-danger" (click)="onDelete()">
        <mat-icon>delete</mat-icon>
        <span>{{ 'common.delete' | transloco }}</span>
      </button>
    </mat-menu>

    <!-- No sub-hero. File-type identity is already carried by the
         corner `<app-type-icon>` in the title-row, and organisation
         renders as a first-class field in the body's Details grid
         below. Duplicating either as sub-hero chrome was the same
         drift trimmed from the control / assessment / document
         drawers — sub-hero should hold state, not descriptive
         properties that live in the body. Context-docs have no state
         axis (they're immutable file records), so no sub-hero. -->

    <!-- Body -->
    <div class="panel-body">
      @if (doc.description) {
        <div class="panel-section">
          <div class="panel-section-label">
            {{ 'panels_ext.section_description' | transloco }}
          </div>
          <p class="panel-desc-text">{{ doc.description }}</p>
        </div>
      }

      <div class="panel-section">
        <div class="panel-section-label">{{ 'panels_ext.section_details' | transloco }}</div>
        <div class="panel-details-grid">
          <div class="panel-detail-item">
            <div class="panel-detail-label">
              {{ 'panels_ext.field_uploaded_by' | transloco }}
            </div>
            <div class="panel-detail-value">
              @if (uploaderName(); as name) {
                <div class="panel-avatar-row uploader-row">
                  <app-user-avatar size="sm" [name]="name" [pictureUrl]="uploaderPictureUrl()" />
                  <span class="uploader-name">{{ name }}</span>
                </div>
              } @else {
                &mdash;
              }
            </div>
          </div>
          <div class="panel-detail-item">
            <div class="panel-detail-label">{{ 'panels_ext.field_file_type' | transloco }}</div>
            <div class="panel-detail-value">{{ fileTypeLabel() }}</div>
          </div>
          <div class="panel-detail-item">
            <div class="panel-detail-label">{{ 'panels_ext.field_file_size' | transloco }}</div>
            <div class="panel-detail-value">{{ formatFileSize(doc.file_size) }}</div>
          </div>
          <div class="panel-detail-item">
            <div class="panel-detail-label">{{ 'panels_ext.field_uploaded' | transloco }}</div>
            <div class="panel-detail-value">{{ formatDate(doc.uploaded_at, 'compact') }}</div>
          </div>
          @if (doc.org_name) {
            <div class="panel-detail-item">
              <div class="panel-detail-label">
                {{ 'panels_ext.field_organization' | transloco }}
              </div>
              <div class="panel-detail-value">{{ doc.org_name }}</div>
            </div>
          }
        </div>
      </div>
    </div>
  }
</app-detail-panel>

<app-context-doc-preview [handler]="contextDocPreview" />
